/** Деньги храним числом в основной единице (гривни), а не в копейках. */
export function formatMoney(amount, currency = 'UAH', locale = 'uk-UA') {
    if (amount === null || amount === undefined || Number.isNaN(amount))
        return '—';
    const fractionDigits = Number.isInteger(amount) ? 0 : 2;
    try {
        const formatted = new Intl.NumberFormat(locale, {
            style: 'decimal',
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits,
        }).format(amount);
        return currency === 'UAH' ? `${formatted} грн.` : `${formatted} ${currency}`;
    }
    catch {
        return `${amount} ${currency}`;
    }
}
export function roundMoney(amount) {
    return Math.round(amount * 100) / 100;
}
//# sourceMappingURL=money.js.map